export default __webpack_public_path__ + "static/media/Ipimage.a3523f19.jpg";